// extracted by mini-css-extract-plugin
module.exports = {"ContentFullScreen2":"ContentRight_ContentFullScreen2__RaASE","bgImage":"ContentRight_bgImage__IMY_O"};